import { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import { ParametrosGerais as ParametrosGeraisModel } from '../../shared/model/parametrosGerais';
import ParametrosGeraisService from '../../services/parametrosGeraisService';
import Spinner from '../../shared/spinner';
import CustomAlert from '../../shared/customAlert';
import InputMask from 'react-input-mask';
import { ProtectedAction } from '../../AccessControl';

function ParametrosGerais() {
    const [alert, setAlert] = useState<{ message: string, type: 'success' | 'warning' | 'error' } | null>(null);
    const [loading, setLoading] = useState(false);
    const [codConvenioRefin, setCodConvenioRefin] = useState<string>('');
    const [codLibCliente, setCodLibCliente] = useState<string>('');
    const [codLibTransfer, setCodLibTransfer] = useState<string>('');
    const [codLibRefin, setCodLibRefin] = useState<string>('');
    const [codBaixaRefin, setCodBaixaRefin] = useState<string>('');
    const [codLibTransferCartaSaldo, setCodLibTransferCartaSaldo] = useState<string>('');

    const parametrosGeraisService: ParametrosGeraisService = new ParametrosGeraisService();

    const listarTodosParametrosGerais = async () => {
        try {
            const responseList = await parametrosGeraisService.listarTodosParametros();
            const json = responseList.data;
            setCodConvenioRefin(json.codConvenioRefin);
            setCodLibCliente(json.codLibCliente);
            setCodLibTransfer(json.codLibTransfer);
            setCodLibRefin(json.codLibRefin);
            setCodBaixaRefin(json.codBaixaRefin);
            setCodLibTransferCartaSaldo(json.codLibTransferCartaSaldo);
        } catch (err: any) {
            setLoading(false);
            console.error(err.response.data);
        }
    }

    const handleSubmit = async (e: any) => {
        e.preventDefault();
        setLoading(true);

        try {
            let parametros_gerais: ParametrosGeraisModel = new ParametrosGeraisModel();
            parametros_gerais.codConvenioRefin = codConvenioRefin;
            parametros_gerais.codLibCliente = codLibCliente;
            parametros_gerais.codLibTransfer = codLibTransfer;
            parametros_gerais.codLibRefin = codLibRefin;
            parametros_gerais.codBaixaRefin = codBaixaRefin;
            parametros_gerais.codLibTransferCartaSaldo = codLibTransferCartaSaldo;
            await parametrosGeraisService.alterarParametrosGerais(parametros_gerais);
            setLoading(false)
            setAlert({ message: 'Alteração realizada com sucesso!', type: 'success' });
        } catch (err: any) {
            setLoading(false);
            setAlert({ message: err.message, type: 'error' });
        }
    }

    useEffect(() => {
        listarTodosParametrosGerais();
    }, []);

    return(
        <div className="position-relative m-md-3 container-fluid SiteFontSize">
            <div className="row col-md-12">
                <h6><strong>Sistema &gt; Parâmetros Gerais</strong></h6>
            </div>
            {alert && (<CustomAlert message={alert.message} type={alert.type} onClose={() => setAlert(null)} />)}
            {loading ? <Spinner loading={loading} /> : (
            <form onSubmit={handleSubmit}>
                <h3>Códigos de Liberação</h3>
                <div style={{ marginTop: '15px' }}>
                    <div className="row">
                        <div className="col-md-3 form-group">
                            <span style={{ textAlign: 'left' }}>Código do Convênio p/ Consulta de Refin</span>
                            <InputMask mask="999999" maskChar={null} type="text" className="form-control form-control-sm brds" style={{ textAlign: 'left' }}
                                value={codConvenioRefin} onChange={(e) => setCodConvenioRefin(e.target.value.replace(/_/g, ''))} />
                        </div>
                        <div className="col-md-2 form-group">
                            <span style={{ textAlign: 'left' }}>Cód Lib Cliente</span>
                            <InputMask mask="999" maskChar={null} type="text" className="form-control form-control-sm brds" style={{ textAlign: 'left' }}
                                value={codLibCliente} onChange={(e) => setCodLibCliente(e.target.value.replace(/_/g, ''))}/>
                        </div>
                        <div className="col-md-2 form-group">
                            <span style={{ textAlign: 'left' }}>Cód Lib Transfer</span>
                            <InputMask mask="999" maskChar={null} type="text" className="form-control form-control-sm brds" style={{ textAlign: 'left' }}
                                value={codLibTransfer} onChange={(e) => setCodLibTransfer(e.target.value.replace(/_/g, ''))}/>
                        </div>
                        <div className="col-md-2 form-group">
                            <span style={{ textAlign: 'left' }}>Cód Lib Transfer Carta Saldo</span>
                            <InputMask mask="999" maskChar={null} type="text" className="form-control form-control-sm brds" style={{ textAlign: 'left' }} 
                                value={codLibTransferCartaSaldo} onChange={(e) => setCodLibTransferCartaSaldo(e.target.value.replace(/_/g, ''))}/>
                        </div>
                        <div className="col-md-2 form-group">
                            <span style={{ textAlign: 'left' }}>Cód Lib Refin</span>
                            <InputMask mask="999" maskChar={null} type="text" className="form-control form-control-sm brds" style={{ textAlign: 'left' }} 
                                value={codLibRefin} onChange={(e) => setCodLibRefin(e.target.value.replace(/_/g, ''))}/>
                        </div>
                        <div className="col-md-3 form-group">
                            <span style={{ textAlign: 'left' }}>Cód Baixa Refin</span>
                            <InputMask mask="999" maskChar={null} type="text" className="form-control form-control-sm brds" style={{ textAlign: 'left' }} 
                                value={codBaixaRefin} onChange={(e) => setCodBaixaRefin(e.target.value.replace(/_/g, ''))}/>
                        </div>
                    </div>
                    <div>
                        <hr className="my-4" />
                        <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                            <ProtectedAction>
                                <button className="w-40 btn btn-lg" id="App-button-cor-principal" onClick={() => window.history.back()}>Voltar</button>
                                <button className="w-40 btn btn-primary btn-lg btn-success" type="submit">Salvar Parâmetros</button>
                            </ProtectedAction>
                        </div>
                    </div>
                </div>
            </form>
            )}
        </div>
    )
}

export default ParametrosGerais;